import React, { useEffect, useState } from 'react';
import PropTypes from 'prop-types';
import Select from 'react-select';
import Api from '../../../services/Api';

const ProductsTypeSelector = ({
  onChanged,
  isMulti,
  selectedId,
}) => {
  const [products, setProducts] = useState([]);

  useEffect(() => {
    Api.get('types/products?per_page=200').then((response) => {
      if (response.status === 200) {
        const mappedValues = response.data.data.map(product => ({
          label: `${product.name} [${product.code}]`,
          value: product.id,
        }));
        setProducts(mappedValues);
      }
    });
  }, []);
  let selectedItem;
  if (selectedId) {
    selectedItem = products.find(x => x.value === selectedId);
  }
  return (
    <Select
      isMulti={isMulti}
      options={products}
      value={selectedItem}
      onChange={(value) => {
        if (onChanged) {
          onChanged(value);
        }
      }}
      placeholder="Select Product Type"
    />
  );
};

ProductsTypeSelector.propTypes = {
  onChanged: PropTypes.func,
  isMulti: PropTypes.bool,
  selectedId: PropTypes.number,
};

ProductsTypeSelector.defaultProps = {
  onChanged: undefined,
  isMulti: false,
  selectedId: undefined,
};

export default ProductsTypeSelector;
